/**
 * MobileMenu - Portal-specific wrapper for shared MobileMenu
 * 
 * Uses the shared @sophy/shared-ui MobileMenu component
 * with portal/patient-specific menu configuration.
 */
import React from "react";
import { MobileMenu as SharedMobileMenu } from "@sophy/shared-ui";

// Import icons from shared-ui
import {
  TemplatesIcon,
  UserProfileIcon,
  SettingsIcon,
  QuestionIcon,
  LogoutIcon,
} from "@sophy/shared-ui";
import MilestonesIcon from "@/assets/icons/milestones.svg";

const MobileMenu = ({ isOpen, onClose, logout }) => {
  // Portal main menu items (fewer than therapist)
  const mainMenuItems = [
    { to: "/programs", icon: TemplatesIcon, labelKey: "menu.programs", alt: "programs" },
    { to: "/milestones", icon: MilestonesIcon, labelKey: "menu.milestones", alt: "milestones" },
    { to: "/myphysio", icon: UserProfileIcon, labelKey: "menu.myphysio", alt: "myphysio" },
    { to: "/preferences", icon: SettingsIcon, labelKey: "menu.settings", alt: "settings" },
  ];

  // Portal footer menu items (help)
  const footerMenuItems = [
    {
      href: "https://hoferdigital.atlassian.net/wiki/spaces/SS/pages/2949447681/Wiki+f+r+Patienten+Athleten+und+Klienten",
      icon: QuestionIcon,
      labelKey: "menu.help",
      alt: "help",
      external: true,
    },
  ];

  return (
    <SharedMobileMenu
      isOpen={isOpen}
      onClose={onClose}
      mainMenuItems={mainMenuItems}
      footerMenuItems={footerMenuItems}
      onLogout={logout}
      logoutIcon={LogoutIcon}
    />
  );
};

export default MobileMenu;


